import { faker } from '@faker-js/faker'

import { OperationType, UserTreatment } from '../../contracts/treatment'
import { asBuilder } from '../asBuilder'

export const getTreatmentTag = asBuilder((): { id: number; name: string } => {
  return {
    id: faker.number.int(),
    name: faker.string.uuid(),
  }
})

export const getTreatmentTagWithOperationType = asBuilder(
  (): { id: number; name: string; operationType: OperationType } => {
    return {
      id: faker.number.int(),
      name: faker.string.uuid(),
      operationType: faker.helpers.enumValue(OperationType),
    }
  },
)

export const getTagMeta = asBuilder((): UserTreatment['tagMeta'] => {
  return {
    name: faker.string.uuid(),
    nameKr: faker.lorem.word(),
  }
})
